import script from "./LegacyMobileNav.vue?vue&type=script&setup=true&lang=js"
export * from "./LegacyMobileNav.vue?vue&type=script&setup=true&lang=js"

import "./LegacyMobileNav.vue?vue&type=style&index=0&id=7a8d9ce2&lang=scss"

const __exports__ = script;

export default __exports__